import { mdlReservationEntryItem } from "../models/domain/ReservationEntryItem";
import { mdlBaseDataResponse } from "../models/service-models/common/BaseDataResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlEntryListFilterRequest } from "../models/service-models/entry-list/EntryListFilterRequest";
import { GetResponse } from "../utils/ApiClient";

namespace EntryListService {
    export async function List(
        pRequest: mdlEntryListFilterRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlReservationEntryItem>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlReservationEntryItem>>>>(
            "entrylist/list",
            pRequest
        );
    }
}
export { EntryListService };
